/**
 * 刻み幅から少数の桁数を算出する
 * @example
 * decimalPoint(1) // 0
 * decimalPoint(0.1) // 1
 * decimalPoint(0.01) // 2
 * @param step 刻み幅
 * @returns 少数の桁数
 */
export const decimalPoint = (step: number | string): number => {
	const stepNum = Number(step);
	if (isNaN(stepNum)) {
		return 1;
	}
	return Math.floor(-Math.log10(stepNum));
};
